import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './GameLayout.module.css';
import PropTypes from 'prop-types';

const GameLayout = ({
    sidebarContent,
    children,
    onCanvasClick,
    canvasRef,
    gameRunning = false,
    onQuit
}) => {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 800);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 800);

            if (canvasRef && canvasRef.current && canvasRef.current.parentElement) {
                const canvas = canvasRef.current;
                const parent = canvas.parentElement;
                // Sync buffer to physical size to prevent stretching
                canvas.width = parent.clientWidth;
                canvas.height = parent.clientHeight;
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        // Extra trigger to catch the DOM change after sidebar hides
        const timeout = setTimeout(handleResize, 10);

        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(timeout);
        };
    }, [canvasRef, gameRunning]);

    const showSidebar = !isMobile || !gameRunning;

    return (
        <div className={styles.container}>
            <div className={`${styles.sidebar} ${!showSidebar ? styles.sidebarHidden : ''}`}>
                <button
                    onClick={() => navigate('/games')}
                    style={{
                        padding: '10px 20px',
                        marginBottom: '20px',
                        background: '#444',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        gap: '8px'
                    }}
                >
                    ← GAMES
                </button>
                {sidebarContent}
            </div>

            <div className={styles.gameArea}>
                {!showSidebar && onQuit && (
                    <div className={styles.topBar}>
                        <button className={styles.quitButton} onClick={onQuit}>EXIT GAME</button>
                    </div>
                )}

                <div className={styles.contentWrapper}>
                    {/* Render canvas if provided */}
                    {canvasRef && (
                        <canvas
                            ref={canvasRef}
                            className={styles.canvas}
                            onClick={onCanvasClick}
                        />
                    )}
                    {/* Render children (SVG game content OR overlays) */}
                    {children}
                </div>
            </div>
        </div>
    );
};

GameLayout.propTypes = {
    sidebarContent: PropTypes.node,
    children: PropTypes.node,
    onCanvasClick: PropTypes.func,
    gameRunning: PropTypes.bool,
    onQuit: PropTypes.func,
    canvasRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    ])
};

export default GameLayout;
